export default {
  data() {
    return {
      pageSizes: [20, 50, 100, 150],
      totalCount: 0,
      listLoading: false,
      page: {
        page_number: 1,
        page_size: 20
      },
      fetchParams: {},
      startPickerOptions: {
        disabledDate: (time) => {
          const disabledEndDate = this.params.end_time ? new Date(this.params.end_time) : null;
          return disabledEndDate && time.getTime() > disabledEndDate.getTime()
        }
      },
      endPickerOptions: {
        disabledDate: (time) => {
          const disabledStartDate = this.params.begin_time ? new Date(this.params.begin_time) : null;
          return disabledStartDate && time.getTime() < disabledStartDate.getTime()
        }
      },
      collapseSearch: false
    }
  },
  methods: {
    handleStartDateChange(value) {
      if (!value) this.params.end_time = undefined
    },
    getEndTime(time) {
      return time + (24 * 60 * 60 * 1000 - 1)
    },
    search() {
      this.page.page_number = 1
      if (this.params.begin_time || this.params.end_time) {
        let { begin_time: start, end_time: end } = this.params
        start = this.$common.formatTimestampLongZone(start)
        if (end) {
          end = this.getEndTime(end)
          end = this.$common.formatTimestampLongZone(end)
        }
        this.fetchParams = { ...this.params, begin_time: start, end_time: end }
      } else {
        this.fetchParams = { ...this.params }
      }
      this.list = []
      this.getList()
    },
    handleSizeChange(val = 20) {
      this.page.page_size = val;
      this.getList();
    },
    handleCurrentChange(val = 1) {
      this.page.page_number = val;
      this.getList();
    }
  }
}